export const themeStorageKey = 'PORTAL_THEME';
export const darkMediaQuery = '(prefers-color-scheme: dark)';
export const themeList = ['light', 'light-hc', 'dark', 'dark-hc', 'autoTheme'];
export const defaultTheme = 'autoTheme';
export const highContrastMediaQueries = [
    '(forced-colors: active)',
    '(prefers-contrast: more)',
    '(inverted-colors: active)',
];
